/* eslint-disable */
export default {
  callerCall: 'Caller',
  transferCall: 'Transfer',
} as const;

// @key: @#@"callerCall"@#@ @source: @#@"Caller"@#@
// @key: @#@"transferCall"@#@ @source: @#@"Transfer"@#@
